// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__ue24r","buttons":"SendReceipts_buttons__2zxC2","email":"SendReceipts_email__jZKLw","bookApptTitle":"SendReceipts_bookApptTitle__2q_3F"};